<template>
  <div style="background-color: #ffffff;min-width: 980px;">
    <el-container>
      <el-header ref="header_">
        <div class="header-nav">
          <div class="header">

            <router-link to="/" style="margin-top: 15px;">
              <img src="http://img.newlong.com.cn/418d1062-3eeb-45ea-b2e5-4c51f5ea800a.svg" alt="newlong"
                class="topLogo">
            </router-link>

            <div class="headerR">

              <form role="search" method="get" class="search-form">
                <el-input placeholder="请输入内容" class="search-field" v-model="search_str" clearable>
                </el-input>
                <router-link :to="{path:'/search',query:{s:search_str}}"
                  style="height:30px;line-height:30px;margin-left: 10px;">
                  <i class="el-icon-search" style="color: orange;font-weight: 900;font-size: 18px;margin-top: 6px;"></i>
                </router-link>
              </form>

              <router-link to="/contact" class="contactLink">联系我们
              </router-link>

            </div>

          </div>
          <div class="nav">
            <ul class="primary-menu">
              <li>
                <router-link to="/">
                  HOME
                </router-link>

              </li>
              <li @mouseenter="enter" @mouseleave="leave" id="gongshijianjie" class="reference">
                <router-link to="/company">公司简介 </router-link>
                <!-- <a href="/company">
                  公司简介
                </a> -->
              </li>
              <!-- <li @mouseenter="enter" @mouseleave="leave" class="reference" id="wangluo">
                <a>
                  网络
                </a>
              </li> -->
              <li @mouseenter="enter" @mouseleave="leave" class="reference" id="chanpin">
                <router-link to="/units">
                  产品介绍
                </router-link>
              </li>
              <li @mouseenter="enter" @mouseleave="leave" class="reference">
                <router-link to="/csr">
                  企业社会责任
                </router-link>
              </li>
              <li @mouseenter="enter" @mouseleave="leave" class="reference">
                <router-link to="/news">
                  新闻
                </router-link>
              </li>
              <li @mouseenter="enter" @mouseleave="leave" class="reference">
                <router-link to="/recruit">
                  加入我们
                </router-link>
              </li>
              <li @mouseenter="enter" @mouseleave="leave" class="reference">
                <router-link to="/contact">联系我们
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <div style="position: fixed;background: #ffffff;height: 60px;left: 0;width: 100%;top: 0px;z-index: 998;"> </div>

        <div style="position: fixed; background: #314478; height: 50px; left: 0; width: 100%; top: 60px;z-index: 998;">
        </div>
      </el-header>

      <el-main ref="main_">
        <router-view :key="$route.fullPath">
        </router-view>
        <!-- </keep-alive> -->

        <!-- <HelloWorld /> -->

      </el-main>
      <el-footer style="margin-top: 75px;" ref="footer_">

        <div class="footer-top">
          <router-link to="/" class="footer-top-left">
            <img src="http://img.newlong.com.cn/0074da28-f50f-4894-927a-d1819cc838b4.png" style="width: 300px;">
          </router-link>
          <div class="footer-top-right">
            <ul>
              <li class="address">{{company.address}}</li>
              <li class="mail">
                <a :href="'mailto:'+company.email">{{company.email}}</a>
              </li>
              <li class="tell" v-for="(tell,tIndex) in company.tells">
                <p>{{tell.key}} <a :href="'tel:'+tell.tell">{{tell.tell}}</a></p>
              </li>
            </ul>
          </div>
        </div>

        <div class="footer-middle">
          <div class="footer-middle-content">

            <div class="footer-middle-content-1">
              <img src="http://img.newlong.com.cn/418d1062-3eeb-45ea-b2e5-4c51f5ea800a.svg">
              <span>
                纽朗公司的独特商标注册。
              </span>
            </div>
            <div class="footer-middle-content-2">
              <img src="http://img.newlong.com.cn/6a314dd2-011a-486c-93e3-ec788f3b1661.svg" class="left-img">
              <p>
                纽朗的企业色彩为三色发(橙色系)和冰蓝色。代表宇宙中闪耀的太阳能和地球环境保护。
              </p>
              <img src="http://img.newlong.com.cn/4024f9ad-92d9-493f-9ce2-c655682be180.svg" class="right-img">
            </div>

          </div>
        </div>

        <div class="footer-bottom">
          <div class="footer-bottom-content">
            <div class="footer-bottom-content-left">
              <ul>
                <li>
                  <router-link to="/">
                    HOME
                  </router-link>
                </li>
                <li>
                  <router-link to="/company">公司简介 </router-link>
                </li>
                <!-- <li><a href="https://www.newlong.com/network/">ネットワーク</a></li> -->
                <li>
                  <router-link to="/units">
                    产品介绍
                  </router-link>
                </li>
                <li>
                  <router-link to="/csr">
                    企业社会责任
                  </router-link>
                </li>
                <li>
                  <router-link to="/news">
                    新闻
                  </router-link>
                </li>
                <li>
                  <router-link to="/recruit">
                    加入我们
                  </router-link>
                </li>
                <li>
                  <router-link to="/contact">联系我们
                  </router-link>
                </li>
                <!-- <li><a href="https://www.newlong.com/privacy-policy/">プライバシー<br class="iPadShow">ポリシー</a></li> -->
              </ul>
            </div>
            <div class="footer-bottom-content-right">
              <ul class="footer-bottom-content-menu">
                <li class="fbcm-item fbcm-top">
                  <router-link to="/units" class=" fbcm-top-t">
                    产品介绍
                  </router-link>
                  <ul class="fbcm-sub-menu">
                    <li class="fbcm-sub-menu-item" v-for="(pg,index) in pgs">
                      <router-link :to="{path:'/units/'+pg.pGLink}" class="i-title">
                        {{pg.pGName}}
                      </router-link>
                      <ul class="fbcm-sub-menu-ul">
                        <li v-for="(p, pIndex) in pg.ps" :key="pIndex">
                          <router-link :to="{path:'/units/'+pg.pGLink+'/'+p.pLink}"> {{p.pName}}</router-link>
                        </li>
                      </ul>
                    </li>

                    <!-- <a class="i-title"
                         href="/units/easy">轻包装相关</a></li> -->
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="footer-bottom-2">
          <div>
            <img src="http://img.newlong.com.cn/10e36991-2701-4bb6-8cbb-5fd6b831e701.png" class="ios_">
            <p>
              NEWLONG PACKAGING MACHINERY (BEIJING) CO., LTD.在自动包装机、袋口缝纫机、热贴机的设计、开发和制造中,获得了ISO9001认证。
            </p>
          </div>
          <div>
            <img src="http://img.newlong.com.cn/5bfb43ca-dd7b-47c5-b709-ef159b6c7cd6.svg" class="isoBG">
            <p>
              纽朗包装机械有限公司第1工厂在空气气囊的设计、开发和制造中取得ISO9001认证。
            </p>
          </div>
        </div>

        <div class="fCopy">
          <a href="http://www.miitbeian.gov.cn">粤ICP备19022012号-1</a>
        </div>
      </el-footer>
    </el-container>
    <div class="float-content" @mouseenter="enter" @mouseleave="leave" v-if="show && float_content_show_id"
      :style="{top:float_content_top+'px'}">
      <i class="tnverted-triangle" :style="{left:tnverted_triangle_left+'px'}">
      </i>
      <ul class="recruit-menu" v-if="float_content_show_id === 'gongshijianjie'">
        <li>
          <router-link to="/company">公司简介 </router-link>
        </li>
        <li>
          <router-link to="/company/greetings">问候</router-link>
        </li>
        <li>
          <router-link to="/company/philosophy">经营理念</router-link>
        </li>
      </ul>

      <!-- <ul class="recruit-menu"
          v-if="float_content_show_id === 'wangluo'">
        <li><a>国内网络</a></li>
        <li><a>工厂</a></li>
        <li><a>海外网络</a></li>
      </ul> -->

      <ul class="product-menu" v-if="float_content_show_id === 'chanpin'">

        <li class="product-item" v-for="(pg , index ) in pgs">
          <router-link :to="{path:'/units/'+pg.pGLink}" class="product-title"> {{pg.pGName}}</router-link>
          <!-- <a class="product-title">{{pg.pGName}}</a> -->
          <ul class="sub-menu">

            <li v-for="(p, pIndex) in pg.ps" :key="pIndex">
              <router-link :to="{path:'/units/'+pg.pGLink+'/'+p.pLink}"> {{p.pName}}</router-link>
            </li>

          </ul>
        </li>

      </ul>

    </div>
  </div>
</template>

<script>
  // import HelloWorld from "./components/HelloWorld.vue";

  export default {
    components: {},
    data() {
      return {
        show: false,
        hover_obj: null,
        float_content_show_id: "",
        float_content_top: 0,
        tnverted_triangle_left: 0,
        company: {},
        minHeight: 100,
        pgs: [],
        search_str: ""
      };
    },
    methods: {
      enter: function (obj) {
        this.hover_obj = obj;
        if (
          obj !== undefined &&
          obj.target !== undefined &&
          obj.target !== null &&
          obj.target.className === "reference"
        ) {
          this.float_content_show_id = obj.target.id;
          var tnverted_triangle_left =
            obj.target.offsetLeft +
            obj.target.offsetParent.offsetLeft +
            obj.target.offsetWidth / 2 -
            8;
          if (this.tnverted_triangle_left !== tnverted_triangle_left) {
            this.tnverted_triangle_left = tnverted_triangle_left;
          }
          if (this.float_content_top === 0)
            this.float_content_top = obj.target.offsetParent.offsetHeight;
        }
        this.show = true;
      },
      leave: function (obj) {
        this.hover_obj = null;
        setTimeout(() => {
          if (this.hover_obj === null) {
            this.show = false;
          }
        }, 150);
      },
      initHeight() {
        var header = this.$refs.header_;
        var main = this.$refs.main_;
        var footer = this.$refs.footer_;
        var height = header.$el.clientHeight + footer.$el.clientHeight + 75;
        main.$el.style.minHeight =
          document.documentElement.clientHeight - height + "px";
      }
    },
    created() { },
    mounted() {
      var that = this;
      window.onresize = () => {
        return (() => {
          that.initHeight();
        })();
      };
      that.initHeight();
      this.$request.get({
        url: "/api/pageData/page_index",
        callback: {
          success: function (data) {
            var company = data.data.company;
            company.tells = JSON.parse(company.tells);
            that.company = company;
            that.pgs = data.data.pgs;
          },
          err: function (err) {
            console.log(err);
          }
        }
      });
    }
  };
</script>

<style lang="css" scoped>
  .fCopy {
    background: #263238;
    color: #fff;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .fCopy a {
    padding: 10px 15px;
    font-size: 75%;
    width: fit-content;
    line-height: 1.5em;
  }

  .iPadHide {
    display: none;
  }

  .el-footer * {
    line-height: normal;
  }

  .footer-bottom-2 {
    background-color: #314478;
    padding: 20px 0;
  }

  .footer-bottom-2 div {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    max-width: 980px;
    width: 100%;
    margin: 0 auto;
    padding: 0 15px;
    text-align: center;
  }

  .footer-bottom-2 p {
    padding-top: 0;
    padding-bottom: 0;
    margin-left: 10px;
    color: #fff;
    font-size: 80%;
    letter-spacing: normal;
    line-height: 1.5em;
    text-align: left;
  }

  .ios_ {
    width: 156px;
    margin: 10px 0;
  }

  .isoBG {
    width: 110px;
    background: #fff;
    height: auto;
  }

  .fbcm-top-t {
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    padding-bottom: 4px;
  }

  .fbcm-sub-menu-ul {
    padding: 0;
  }

  .fbcm-sub-menu-ul li {
    width: 135px;
  }

  .footer-bottom-content-menu {
    text-align: left;
    padding: 0;
    margin: 0;
  }

  .footer-bottom-content-menu a {
    color: #ffffff;
    text-align: left;
    font-size: 13px;
  }

  .fbcm-sub-menu {
    padding: 0;
    margin-top: 4px;
  }

  .fbcm-sub-menu-item {
    float: left;
    margin-right: 15px;
  }

  .fbcm-sub-menu-item a {
    margin-top: 5px;
  }

  .i-title {
    font-weight: bold;
    font-size: 14px !important;
  }

  .footer-bottom-content-left {
    padding: 0;
    margin: 0;
  }

  .footer-bottom-content-left ul {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    font-size: 99%;
    padding: 0;
    margin: 0;
  }

  .footer-bottom-content-left li {
    text-align: left;
    line-height: normal;
    letter-spacing: normal;
    padding: 3px 10px;
    font-size: 95%;
    width: 130px;
  }

  .footer-bottom-content-left a {
    color: #fff;
    font-size: 14px;
  }

  .footer-middle-content {
    display: block;
    margin: 0 auto;
    text-align: center;
    /* padding: 10px 15px; */
  }

  .footer-middle-content-2 {
    max-width: 980px;
    margin: 0 auto;
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    padding-bottom: 10px;
    height: 45px;
    letter-spacing: normal;
    justify-content: space-between;
  }

  .footer-middle-content-2 .left-img {
    width: 150px;
    margin-right: 10px;
  }

  .footer-middle-content-2 .right-img {
    width: 60px;
    margin-left: 10px;
  }

  .footer-middle-content-2 p {
    font-size: 70%;
    line-height: 1.5em;
    position: relative;
    top: 5px;
    font-size: 12px;
  }

  .footer-middle-content-1 {
    display: flex;
    text-align: center;
    display: block;
    margin: 0 auto;
    text-align: center;
    padding-top: 10px;
    font-size: 13px;
  }

  .footer-middle-content-1 span {
    font-size: 85%;
    position: relative;
    top: -3px;
    letter-spacing: normal;
  }

  .footer-middle-content-1 img {
    width: 170px;
  }

  .footer-top {
    background-color: #fff;
    width: 980px;
    margin: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 15px;
    max-width: 980px;
    justify-content: center;
  }

  .footer-top-left {
    width: 300px;
  }

  .footer-top-right {
    text-align: left;
    width: calc(100% - 315px);
    max-width: 590px;
    margin-left: 15px;
    font-size: 13px;
    /* font: inherit; */
  }

  .footer-top-right ul {
    letter-spacing: 0.1em;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 0;
    font-weight: 500;
    margin-top: 0;
  }

  .footer-top-right li {
    float: left;
    margin-right: 5px;
    line-height: 1.5em;
  }

  .footer-top-right li a {
    color: #2c3e50;
  }

  .address {
    width: 260px;
    vertical-align: bottom;
    display: inline-block;
    position: relative;
    margin-top: 2.5px;
  }

  .mail {
    margin-top: 2.5px;
    width: calc(100% - 270px);
  }

  .mail a {
    color: #0066cb !important;
    font-weight: 700;
  }

  .tell {
    line-height: 1.5em;
    margin-right: 10px;
  }

  .tell p {
    line-height: 1.5em;
    letter-spacing: 0.1em;
    font-size: 95%;
    margin: 0;
    margin-right: 5px;
  }

  .tell a {
    line-height: 1.5em;
    float: right;
    margin-left: 2.5px;
  }

  #app {
    font-family: Helvetica, "PingFang SC", Arial, sans-serif;
    /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
  }

  p {
    font-size: 98.5%;
    margin: 0;
    padding: 0;
    line-height: 2em;
    letter-spacing: 0.1em;
  }

  ul,
  li {
    list-style: none;
    text-decoration: none;
  }

  a {
    cursor: pointer;
    display: block;
    text-decoration: none;
  }

  .header {
    width: 980px;
    background-color: aliceblue;
    background: #fff;
    text-align: center;
    margin: 0 auto;
    height: 60px;
    line-height: 60px;
    line-height: 60px;
  }

  .el-footer {
    height: unset !important;
    padding: 0 !important;
    background-color: #ffffff !important;
  }

  .footer-middle {
    background-color: #eceff1;
  }

  .footer-bottom {
    background: #314478;
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  }

  .footer-bottom-content {
    display: flex;
    padding-top: 15px;
    padding-bottom: 15px;
    width: 100%;
    max-width: 980px;
    margin: 0 auto;
    color: #ffffff;
  }

  .footer-content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 15px;
    max-width: 980px;
    justify-content: center;
    padding: 0 15px;
    display: block;
    margin: 0 auto;
  }

  .topLogo {
    width: 240px;
    float: left;
  }

  .contactLink {
    background: #f68100;
    color: #fff;
    border-radius: 4px;
    padding: 3px 15px;
    line-height: normal;
    font-size: 95%;
    border: 1px solid #f68100;
    text-decoration: none;
  }

  .headerR {
    display: flex;
    float: right;
  }

  .search-form {
    display: flex;
    justify-content: space-between;
    width: 200px;
    margin: 0 25px 0 35px;
  }

  .headerR .el-input__inner {
    width: 175px;
    height: 100% !important;
    border-radius: 4px;
    border-color: #f68100;
    outline: none;
  }

  .search-submit {
    width: auto;
    top: -5px;
  }

  .search-form button {
    background: #fff;
    border: none;
    font-size: 20px;
    color: #f68100;
  }

  .nav {
    min-width: 980px;
    background: #314478;
    height: 50px;
    text-align: center;
    line-height: 50px;
  }

  .header-nav {
    position: fixed;
    min-width: 980px;
    width: 980px;
    z-index: 999;
    left: 0;
    right: 0;
    margin: 0 auto;
    display: flex;
    background-color: #000000;
    flex-direction: column;
  }

  .el-header {
    padding: 0px !important;
    height: 110px !important;
    display: flex;
    justify-content: center;
  }

  .search-field {
    height: 30px !important;
    line-height: 30px !important;
  }

  .search-field>>>.el-input__inner {
    line-height: 30px !important;
    height: 30px !important;
  }

  .primary-menu {
    display: flex;
    justify-content: center;
  }

  .primary-menu a {
    /* font-weight: 700; */
    letter-spacing: 2px;
  }

  .primary-menu>li {
    border-left: 1px solid #f68100;
    margin: 10px 0;
    height: 30px;
    line-height: 30px;
    float: left;
    font-size: 95%;
    padding: 0 20px;
    position: relative;
    list-style: none;
    color: #fff;
  }

  .primary-menu>li:nth-last-child(1) {
    border-right: 1px solid #f68100;
  }

  /* .primary-menu > li > a{
      margin: 5px 0;
} */

  .float-content {
    width: 100%;
    /* padding: 0px 15px 15px 15px; */
    background-color: #f68100;
    z-index: 2000;
    position: fixed;
    left: 0;
  }

  .tnverted-triangle {
    width: 0;
    height: 0;
    top: 0px;
    border-width: 10px;
    border-style: solid;
    z-index: 2001;
    position: absolute;
    border-color: #314478 transparent transparent transparent;
  }

  .recruit-menu {
    /* justify-content: flex-start; */
    justify-content: center;
    display: flex;
    padding: 20px 15px;
  }

  .recruit-menu li {
    /* text-align: left; */
    float: left;
    padding: 0 15px;
  }

  .recruit-menu>li a {
    font-size: 90%;
    letter-spacing: normal;
    display: block;
    line-height: 1.4;
    color: #fff;
  }

  .product-menu {
    justify-content: center;
    display: flex;
    text-align: left;
    padding: 20px 15px;
  }

  .product-menu .product-item {
    margin: 0 50px 0 0;
    font-size: 13px;
    color: #ffffff;
  }

  .product-item .product-title {
    border-bottom: #fff solid 1px;
    padding: 0 0 5px 0;
    font-weight: 700;
    font-size: 97%;
    width: 100%;
  }

  .sub-menu {
    margin-top: 5px;
    text-align: left;
    padding: 0;
  }

  .sub-menu li {
    padding: 3px 0 0 0;
    font-size: 96%;
  }
</style>